import { ReactNode } from "react";
import {
  Box,
  Paper,
  Typography,
  Collapse,
  SxProps,
  Theme,
} from "@mui/material";
import { Error } from "@mui/icons-material";

type CollapsibleFormElementProps = {
  title: string;
  children: ReactNode;
  containerSx?: SxProps<Theme>;
  contentSx?: SxProps<Theme>;
  onExpandChange?: (expanded: boolean) => void;
  hasError?: boolean;
};

export default function CollapsibleFormElement({
  title,
  children,
  containerSx,
  contentSx,
  hasError = false,
}: CollapsibleFormElementProps) {
  return (
    <Box sx={containerSx}>
      <Paper
        elevation={0}
        sx={{
          border: hasError ? "1px solid" : "1px solid",
          borderColor: hasError ? "error.main" : "divider",
          borderRadius: 1,
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            p: 1.5,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            backgroundColor: "background.paper",
            borderBottom: "1px solid",
            borderColor: "divider",
          }}
        >
          <Box>
            <Typography variant="subtitle1" fontWeight="bold">
              {title}
            </Typography>
          </Box>
          <Box>
            {hasError && (
              <Error sx={{ color: "error.main", cursor: "default" }} />
            )}
          </Box>
        </Box>

        <Collapse in={true}>
          <Box
            sx={{
              p: 2,
              backgroundColor: "#f9f9f9",
              ...(contentSx || {}),
            }}
          >
            {children}
          </Box>
        </Collapse>
      </Paper>
    </Box>
  );
}
